import React from "react";
import Amenities from "./Amenities";
import PracticeLanguages from "./PracticeLanguages";
import Technology from "./Technology";

const PracticeHighlights = () => {
  return (
    <div className="practice-highlights">
      <div className="amenities-technology-section full-width-container display-flex">
        <div className="col-md-6">
          <Amenities />
        </div>
        <div className="col-md-6">
          <Technology />
        </div>
      </div>
      <div className="practiceLanguageSection">
        {/* <div className="col-md-6"> */}
        <PracticeLanguages />
        {/* </div> */}
        {/* <div className="col-md-6" /> */}
      </div>
    </div>
  );
};
export default PracticeHighlights;
